/**
 * CANDY SHIPPING JAR
 * Fills the jar-shaped free-shipping indicator as the cart total changes,
 * using the same PUB_SUB_EVENTS.cartUpdate bus as the add-on guard — no
 * extra network requests beyond what a normal cart change already triggers.
 */
(function () {
  // Same money-format parser used by the bundle builder (data-money-format
  // sentinel + shop.money_format's {{amount}} token), duplicated here on
  // purpose rather than shared: two small, independent snippets are safer
  // to touch than a coupling between unrelated sections.
  function formatNumber(value, decimals, decimalSep, thousandSep) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    return decimals > 0 ? parts.join(decimalSep) : parts[0];
  }

  function formatMoney(cents, format) {
    format = format || '{{amount}}';
    var value = cents / 100;
    var tokenMatch = format.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var token = tokenMatch ? tokenMatch[1] : 'amount';
    var formattedAmount;
    switch (token) {
      case 'amount_no_decimals':
        formattedAmount = formatNumber(value, 0, '', ',');
        break;
      case 'amount_with_comma_separator':
        formattedAmount = formatNumber(value, 2, ',', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedAmount = formatNumber(value, 0, '', '.');
        break;
      case 'amount_with_space_separator':
        formattedAmount = formatNumber(value, 2, ',', ' ');
        break;
      case 'amount_no_decimals_with_space_separator':
        formattedAmount = formatNumber(value, 0, '', ' ');
        break;
      default:
        formattedAmount = formatNumber(value, 2, '.', ',');
    }
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, formattedAmount);
  }

  function update(totalCents) {
    document.querySelectorAll('[data-shipping-jar]').forEach(function (jar) {
      var threshold = parseInt(jar.dataset.thresholdCents, 10);
      if (!threshold) return;

      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      var unlocked = totalCents >= threshold;
      var wasUnlocked = jar.classList.contains('is-complete');

      var fill = jar.querySelector('[data-shipping-fill]');
      var message = jar.querySelector('[data-shipping-message]');
      if (fill) fill.style.height = pct + '%';

      jar.classList.toggle('is-complete', unlocked);
      if (unlocked && !wasUnlocked) {
        jar.classList.add('candy-jar-pop');
        setTimeout(function () {
          jar.classList.remove('candy-jar-pop');
        }, 700);
      }

      if (message) {
        if (unlocked) {
          message.innerHTML = '🎉 Gratisversand freigeschaltet!';
        } else {
          var remaining = threshold - totalCents;
          message.innerHTML =
            'Nur noch <strong>' +
            formatMoney(remaining, jar.dataset.moneyFormat) +
            '</strong> — dann reisen deine Süßigkeiten gratis zu dir.';
        }
      }
    });
  }

  function refreshFromServer() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        update(cart.total_price);
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event && event.cartData;
      if (cartData && typeof cartData.total_price !== 'undefined') {
        update(cartData.total_price);
      } else {
        refreshFromServer();
      }
    });
  }

  document.addEventListener('cart:refresh', refreshFromServer);
})();
